import React from 'react'
import classNames from 'classnames'

export const Paragraph = (props) => {

  let paragraphClassNames = classNames([
    'my-4',
    'text-lg',
  ], props.className)

  if (props.bold) {
    paragraphClassNames.push('font-bold')
  }

  return (
    <div className={paragraphClassNames}>
      {props.children}
    </div>
  );
};

export default Paragraph;